module.exports = __webpack_public_path__ + "media/assets/images/blog/redmine-e55a71cc64bf89a00a54ab58abe8ff90.png";